import { FC, RefObject } from "react";
import { Box } from "@otrium/core";
import { t } from "@lingui/macro";
import { find } from "lodash-es";
import { useFilterApplied } from "src/organisms/AlgoliaProductList/useFilterApplied";
import { Radio } from "src/atoms/Radio";
import {
  FilterContentWrapper,
  OutsideClickableWrapper,
  ScrollWrapper,
} from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/DesktopFilter.styled";
import { useLingui } from "@lingui/react";

interface Props {
  items: { count: number; isRefined: boolean; label: string; value: string }[];
  refine: (value: string[]) => void;
  outerRef: RefObject<HTMLDivElement>;
  onClose: () => void;
  currentRefinement: string | null;
}

const PromotionFilter: FC<Props> = ({
  items,
  currentRefinement,
  refine,
  onClose,
  outerRef,
}) => {
  const { i18n } = useLingui();
  const { handleRefine, setFilterApplied } = useFilterApplied(items, refine);
  const handleAllClick = () => {
    if (!currentRefinement) {
      return;
    }
    const selected = find(items, { label: currentRefinement });
    if (selected) {
      refine(selected.value as unknown as string[]);
      setFilterApplied(true);
    }
  };

  return (
    <OutsideClickableWrapper handler={onClose} outerRef={outerRef}>
      <ScrollWrapper>
        <FilterContentWrapper as="ul">
          <Box sx={{ lineHeight: "36px" }} as="li">
            <Radio
              name={t(i18n)`All`}
              checked={!currentRefinement}
              onChange={handleAllClick}
            />
          </Box>
          {items.map((item) => {
            const splitLabel = item.label.split("||");
            return (
              <Box
                key={`promotionFilterItem-${splitLabel[0]}`}
                sx={{ lineHeight: "36px" }}
                as="li"
              >
                <Radio
                  id={splitLabel[0]}
                  name={splitLabel[1]}
                  checked={item.isRefined}
                  onChange={handleRefine(item.value as unknown as string[])}
                />
              </Box>
            );
          })}
        </FilterContentWrapper>
      </ScrollWrapper>
    </OutsideClickableWrapper>
  );
};

export default PromotionFilter;
